import { useMemo, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TEXT =
    "You don’t need a marketing team, a Google/Meta ads specialist, an SEO expert, a copywriter, a graphic designer, a video editor, a creative strategist, a customer researcher, a business consultant, a costly full-service agency or an in-house team.";

const Word = ({ progress, range, children }) => {
    const color = useTransform(progress, range, ["#D9D5CC", "#0B0812"]);
    return (
        <motion.span style={{ color }} className="inline-block">
            {children}&nbsp;
        </motion.span>
    );
};

export const TimeBack = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
    const words = useMemo(() => TEXT.split(" "), []);

    return (
        <section ref={ref} data-testid="timeback-section" className="relative h-[340vh]">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <div className="mx-auto w-full max-w-6xl px-6 sm:px-12">
                    <p
                        data-testid="timeback-eyebrow"
                        className="mb-8 text-xs font-bold uppercase tracking-[0.22em] text-neutral-400"
                    >
                        Why Purple Business
                    </p>
                    <h2
                        data-testid="timeback-headline"
                        className="font-display text-4xl font-bold leading-[1.14] tracking-[-0.02em] sm:text-6xl lg:text-7xl"
                    >
                        {words.map((w, i) => (
                            <Word
                                key={i}
                                progress={scrollYProgress}
                                range={[i / words.length, (i + 1) / words.length]}
                            >
                                {w}
                            </Word>
                        ))}
                    </h2>
                </div>
            </div>
        </section>
    );
};
